import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import ReferralFlow from './components/ReferralFlow/ReferralFlow';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/get-referral" element={<ReferralFlow />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App; 